import axios from 'axios';

class Request {
  constructor() {
    this.axios = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      withCredentials: false,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  send(op, data) {
    op.headers = op.headers ? op.headers : {};
    return this.axios({
      method: op.method,
      url: op.url,
      headers: Object.assign({}, op.headers, {
        'Content-Type': 'application/json',
      }),
      params: op.qs,
      data,
    })
      .then(res => res.data)
      .catch((err) => {
        throw err.response;
      });
  }
}

export default new Request();
